// extracted by mini-css-extract-plugin
export default {"err-wrapper":"styles_err-wrapper__WJzLD","err-msg":"styles_err-msg__WFNTU","icon":"styles_icon__RIsRB"};